import React, { useState, useRef, useCallback } from "react";
import PlaylistDetails from "./PlaylistDetails";
import EditPlaylistDetails from "./EditPlaylistDetails";
import "./PlaylistDetails.css";

interface PlaylistContainerProps {
    playlistId: string;
}

const PlaylistContainer: React.FC<PlaylistContainerProps> = ({ playlistId }) => {
    const [isEditMode, setIsEditMode] = useState(false);
    const saveFunctionRef = useRef<(() => Promise<boolean>) | null>(null);

    const registerSaveFunction = useCallback((fn: () => Promise<boolean>) => {
        saveFunctionRef.current = fn;
    }, []);

    const handleSaveComplete = () => {
        setIsEditMode(false);
        // Instead of reloading, we'll just update the state
        // The parent component will handle refreshing the data
    };

    const handleCancelEdit = () => {
        setIsEditMode(false);
    };

    const handleEnterEditMode = () => {
        setIsEditMode(true);
    };

    return (
        <div className="playlist-container-wrapper">
            {isEditMode ? (
                <EditPlaylistDetails
                    playlistId={playlistId}
                    onSaveComplete={handleSaveComplete}
                    onCancel={handleCancelEdit}
                    registerSaveFunction={registerSaveFunction}
                />
            ) : (
                <PlaylistDetails
                    playlistId={playlistId}
                    onEdit={handleEnterEditMode}
                />
            )}
        </div>
    );
};

export default PlaylistContainer; 